"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noJitter = void 0;
function noJitter(delay) {
    return delay;
}
exports.noJitter = noJitter;
